import { render, staticRenderFns } from "./LegoControlCardDone.vue?vue&type=template&id=f1001af8"
import script from "./LegoControlCardDone.vue?vue&type=script&lang=js"
export * from "./LegoControlCardDone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports